import { DialogStepSchema } from '@feedyou-ai/feedbot-schema'

import { GetUsedDialogs } from '../../../types'

export const getUsedDialogs: GetUsedDialogs<DialogStepSchema> = (
  { dialog, disabled },
  enabledOnly = false
) => {
  if (enabledOnly && disabled) {
    return []
  }

  if (!dialog) {
    return []
  }

  return [dialog]
}
